import React, { Component } from "react";
import axios from '../../../util/axios';
import { trackPromise } from "react-promise-tracker";
import Back from '../../../components/common/Back';
import Alertmessage from '../../../components/common/alertMessage';

const validEmailRegex = 
  RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);


class CreateApplicantView extends Component {

    getCobrandById(cobrandId) {
        var cobrands = JSON.parse(localStorage.getItem("userData")).cobrands;
        var index = cobrands.findIndex(function(cobrand, i) {
          return cobrand.id.toString() === cobrandId;
        });
        return index > -1 ? cobrands[index] : cobrands[0];
    }

    
    state = {
        username: "",
        fname:"",
        lname:"",
        cobrands:[],
        id:"",
        cobrand: this.props.match
        ? this.getCobrandById(this.props.match.params.cobrandId)
        : JSON.parse(localStorage.cobrandId),
        errors: {
            username: '',
            fname: '',
            lname: '',
        },
		creationError: false,
        errorMessage:"",
        successMessage:"",
        nousername:""            
    };

    componentDidMount() {

	};    
    handleCreateUserSubmit = async event => {
        event.preventDefault();
		this.setState({ creationError: false });
        this.setState({ errorMessage: "" });
		const data = {};
        data.username = this.state.username;
        data.fname = this.state.fname.toLowerCase();
        data.lname = this.state.lname.toLowerCase();
        data.role = "borrower";
        const obj = {};
        obj.id = localStorage.cobrandId;
        data.cobrands= [obj];

        if(data.username == "" || data.fname == "" || data.lname == ""){
            return;
        }

        trackPromise(
            axios.post('/api/user/createUser', data, {
                headers: {
                    Authorization: JSON.parse(localStorage.getItem("userData")).token,
                    "Cobrand-Id": this.state.cobrand
                }
            })
            .then(res => {
				this.setState({creationError: false});
                this.setState({ successMessage: "Applicant successfully created" });
                var delayInMilliseconds = 4000; //4 second
                var that = this;
                setTimeout(function() {
                    that.setState({ successMessage: "" , username: "",fname:"",lname:""});
                }, delayInMilliseconds);
            })
            .catch(err => {
				if (err.response.data && err.response.data.errorMessage) {
                    if (err.response.data.errorCode && err.response.data.errorCode === "Y400") var errorMessage = "Applicant already exists";
					this.setState({ errorMessage: errorMessage || err.response.data.errorMessage });
				}
				this.setState({creationError: true});
            })
        );
    };

    handleChange = (event) => {
        event.preventDefault();      
        const { name, value } = event.target;
        let errors = this.state.errors;      
        this.setState({errors, [name]: event.target.value.replace(/[^\w\s]/gi, "")}, ()=> {});
    };

    handleChangeEmail = (event) => {
        event.preventDefault();      
        const { name, value } = event.target;
        let errors = this.state.errors;
        this.setState({errors, [name]: event.target.value}, ()=> {});
    };

    handleFocusOut = (event) =>{
                event.preventDefault();
                const { name, value } = event.target;
                
                let errors = this.state.errors;
              
                switch (name) {
                  case 'username': 
                    errors.username = 
                      validEmailRegex.test(value)
                        ? ''
                        : 'Email is not valid!';
                    break;            
                  case 'fname': 
                    errors.fname = 
                      value.length < 0
                        ? 'Name cannot be left blank!'
                        : '';
                    break;
                  case 'lname': 
                    errors.lname = 
                      value.length < 0
                        ? 'Last Name cannot be left blank!'
                        : '';
                    break;
                  default:
                    break;
                }
              
                this.setState({errors, [name]: value}, ()=> {});
    };
    
    handleBackNavigation = () => {
        window.location.href = "/userMgmt"; 
    };

    render() {
        const {errors} = this.state;
        const isEnabled = this.state.username.length > 0 && this.state.fname.length > 0 && this.state.lname.length > 0;    
        return (
            <React.Fragment>
            <div className="container main">
            <div className="mt-4">
            <Back uri={"/applicantMgmt/" + this.state.cobrand} />
            </div>                
            <div className="heading mt-4 mb-2">Create Applicant</div>
            <form className="mt-4" onSubmit={this.handleSubmit} noValidate>
                <div className="">
                    <div className="col-6 mt-4">
                        <input required type="email" className={`form-control ${this.state.nousername}`} placeholder="Email" name="username" value={this.state.username} onChange={this.handleChangeEmail} onBlur={this.handleFocusOut} noValidate/>
                        {errors.username.length > 0 && <span className='error'>{errors.username}</span>}
                    </div>
                    <div className="col-6 mt-4">
                        <input required type="text" className="form-control" placeholder="First name" name="fname" value={this.state.fname} onChange={this.handleChange} noValidate/>
                        {errors.fname.length > 0 && <span className='error'>{errors.fname}</span>}
                    </div>
                    <div className="col-6 mt-4">
                        <input required type="text" className="form-control" placeholder="Last name"name="lname" value={this.state.lname} onChange={this.handleChange} noValidate/>
                        {errors.lname.length > 0 && <span className='error'>{errors.lname}</span>}
                    </div>
                    <div className="col-6 mt-4 ex">
                    { this.state.creationError && 
							<Alertmessage message={this.state.errorMessage} alertType={'alert-danger'}/>
                        }
                    { this.state.successMessage !== "" && 
                        <Alertmessage message={this.state.successMessage} alertType={'alert-success'}/>
                    }                        
                    </div>   
                    <div className="col-6 mt-4 text-right submit">
                            <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.handleCreateUserSubmit}
                            disabled={!isEnabled}>
                            Create Applicant
                            </button>
                    </div>                                       
                </div>
            </form>
            </div>
            </React.Fragment>
        );
    }
}

export default CreateApplicantView;
